module.exports = __webpack_public_path__ + "static/media/buisiness@10x.1d5050ef.png";